import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import PropertyForm from '../Components/Properties/PropertyForm'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useParams,useNavigate } from 'react-router-dom';

import EditPropertyForm from '../Components/Properties/EditPropertyForm';
const EditProperty = () => {
    const {id} = useParams()
    const [propertyName, setPropertyName] = useState("")
    const navigate = useNavigate()
    const [propertyStartingPrice, setPropertyStartingPrice] = useState("")
    const [propertyLocation, setPropertyLocation] = useState("")
    const [propertyMap, setPropertyMap] = useState("")
    const [propertyImages, setPropertyImages] = useState([])
    const [propertyCoverImages, setPropertyCoverImages] = useState([])
    const [propertyDescription, setPropertyDescription] = useState("")
    const [youtubeVideo, setYoutubeVideo] = useState("")
    const [imageUrl, setImageUrl] = useState("")
    const [propertyType, setPropertyType] = useState("")
    const [propertyMainImage, setPropertyMainImage] = useState("")
    const [rooms, setRooms] = useState([])
   const [propertyDescriptionTitle, setPropertyDescriptionTitle] = useState("")
    const [singleRoom, setSingleRoom] = useState({
        roomTitle:"",
        roomImage:"",
        roomContent:"",
        roomPrice:""
    })
    const [roomImageUrl, setRoomImageUrl] = useState("")
    const addImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setImageUrl(downloadURL)
         setPropertyImages([...propertyImages,downloadURL])
         console.log(downloadURL)
       });
     }
   );
   }
   const addCoverImage = (e) =>{
    e.preventDefault()
const file = e.target[0]?.files[0]
if (!file) return;
const storeRef = storageRef(storage, `files/${file.name}`);
const uploadTask = uploadBytesResumable(storeRef, file);

uploadTask.on("state_changed",
 (snapshot) => {
   
 },
 (error) => {
   alert(error);
 },
 () => {
   getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    
     setPropertyCoverImages([...propertyCoverImages,downloadURL])
     console.log(downloadURL)
   });
 }
);
}
   const addRoomImage = (e) =>{
    e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setRoomImageUrl(downloadURL)
         setSingleRoom({...singleRoom,roomImage:downloadURL})
         console.log(downloadURL)
       });
     }
   );
   }
   const handleAddProperty = () =>{
    const docRef = doc(db, "properties",id);
    updateDoc(docRef,{
       name: propertyName,
       price: propertyStartingPrice,
       location: propertyLocation,
       map: propertyMap,
       images: propertyImages,
       description: propertyDescription,
       type: propertyType,
       youtubeId: youtubeVideo,
       rooms:rooms,
       coverImages:propertyCoverImages,
       mainImage:propertyMainImage
    })
    navigate("/properties")
   
   }
   const fetchProperty = async () =>{
    const docRef = doc(db, "properties", id);
const docSnap = await getDoc(docRef);
      
if (docSnap.exists()) {
  console.log("Document data:", docSnap.data());
  const data = docSnap.data()
  setPropertyName(data?.name)
    setPropertyDescription(data?.description)
    setPropertyStartingPrice(data?.price)
    setPropertyImages(data?.images)
    setPropertyCoverImages(data?.coverImages)
    setPropertyMap(data?.map)
    setYoutubeVideo(data?.youtubeId)
    setPropertyType(data?.type)
    setPropertyLocation(data?.location)
    setPropertyDescriptionTitle(data?.propertyDescriptionTitle)
    setRooms(data?.rooms)
} else {
  // docSnap.data() will be undefined in this case
  console.log("No such document!");
}
   }
   useEffect(() => {
    fetchProperty()
   
     
   }, [])
   
  return (
    <div className=' bg-gray-200   grid-flow-col' >
        <MultiLevelSidebar />
        <EditPropertyForm propertyName={propertyName}
         setPropertyName={setPropertyName}
         propertyType={propertyType}
         setPropertyType={setPropertyType}
         propertyLocation={propertyLocation}
         setPropertyLocation={setPropertyLocation}
         propertyStartingPrice={propertyStartingPrice}
         setPropertyStartingPrice={setPropertyStartingPrice}
         propertyMap={propertyMap}
         setPropertyMap={setPropertyMap}
         propertyCoverImages={propertyCoverImages}
         addCoverImage={addCoverImage}
         setPropertyCoverImages={setPropertyCoverImages}
         youtubeVideo={youtubeVideo}
         setYoutubeVideo={setYoutubeVideo}
          propertyDescription={propertyDescription}
           setPropertyDescription={setPropertyDescription}
            imageUrl={imageUrl}
            rooms={rooms}
            singleRoom={singleRoom} 
            setSingleRoom={setSingleRoom}
            setRooms={setRooms}
            addRoomImage={addRoomImage}
            roomImageUrl={roomImageUrl}
             setImageUrl={setImageUrl}
            addImage={addImage}
             propertyImages={propertyImages}
             handleAddProperty={handleAddProperty}
              setPropertyImages={setPropertyImages} />
    </div>
  )
}

export default EditProperty